import React, { FC, memo, PropsWithChildren, useEffect } from "react";
import { Portal } from "./portal";
import styled from "styled-components";

interface PopupProps {
  onClose: () => void;
  isOpen: boolean;
}

const ScrollOffOnMount = memo(() => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  
  return null;
});

export const Popup: FC<PropsWithChildren<PopupProps>> = memo(({ children, isOpen, onClose }) => {

  return (
    <Portal>
      {isOpen && <ScrollOffOnMount />}

      <PopUp
        role="dialog"
        style={{ display: isOpen ? 'flex' : 'none' }}
      >
        <Backdrop
          role="button"
          onClick={onClose}
          tabIndex={0}
        />
        <PopUpContent>
          {children}
        </PopUpContent>
      </PopUp>
    </Portal>
  );
});


const PopUp =
  styled.div((props) => props?.theme?.themeConfig?.popUp?.styles);


const Backdrop =
  styled.div((props) => props?.theme?.themeConfig?.popUp?.backdrop?.styles);


const PopUpContent =
  styled.div((props) => props?.theme?.themeConfig?.popUp?.popUpContent?.styles);
